module.exports = __webpack_public_path__ + "media/images/icons/search-8a32990ab820579216006eea1bee248c.png";